/* App-wide UI flags that several pages toggle (currently: the microphone setup dialog). */
import { useSyncExternalStore } from 'react';
import { Emitter } from '../core/events';

let micSetupOpen = false;
const events = new Emitter<{ change: undefined }>();
const subscribe = (fn: () => void) => events.on('change', fn);

export function openMicSetup(): void {
  micSetupOpen = true;
  events.emit('change', undefined);
}

export function closeMicSetup(): void {
  micSetupOpen = false;
  events.emit('change', undefined);
}

export const useMicSetupOpen = (): boolean => useSyncExternalStore(subscribe, () => micSetupOpen);
